import { useEffect, useState } from "react";

/**
 * Hook per debounce di un valore
 * @param value - Il valore da debounce
 * @param delay - Il delay in millisecondi (default: 500ms)
 * @returns Il valore debounced
 */
export const useDebounce = <T>(value: T, delay = 500): T => {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};
